import React from "react";
import AntEmpty, { EmptyProps } from "antd/lib/empty";

import "./empty.less";

export const Empty = (props: EmptyProps) => <AntEmpty {...props} />;
